/* DVR - O DESCRITIVO DA ARTE ENTRA NA BUSCA DA VITRINE (Claude, 22/10/2026).

   O DEFEITO. O Fredy pesquisou "olho" na vitrine do Vestuario e a camiseta
   Cogumelo Forma Organica nao apareceu, apesar de a arte ter um olho azul
   enorme no meio. As buscas da linha leem o nome do cartao, as colecoes, as
   tags e o endereco, e nenhum desses textos diz o que esta DESENHADO na
   estampa. Era o limite que o proprio dvr-busca.js ja avisava no comentario
   do alto dele: "palavra que descreve um desenho que nenhum texto menciona
   nao tem como aparecer".

   O MATERIAL JA EXISTIA: o metafield custom.texto_arte de cada peca, uma
   descricao longa da arte em portugues. O snippet dvr-arte-b.liquid publica
   ele em window.DVR_VITRINE.b (e no apelido window.DVR_ARTE_TXT), ja virado
   em saco de palavras: minusculo, sem acento, sem pontuacao, sem repetir e
   sem as palavras vazias do portugues.

   COMO ESTE ARQUIVO LIGA UMA COISA NA OUTRA, e por que assim. O tema escreve
   as colecoes e as tags de cada produto no proprio cartao, no atributo
   data-dv-keys, e as DUAS buscas da linha leem esse atributo: o indiceDe() do
   dvr-busca.js, que e quem manda na caixa hoje, e o textoDe() do
   dvr-vitrine2.js, que e o motor por baixo. Entao este arquivo nao mexe em
   busca nenhuma: ele so ACRESCENTA as palavras da arte no data-dv-keys do
   cartao. As duas passam a achar a estampa pelo desenho sem que uma linha
   delas seja alterada, e tirando a linha que carrega este arquivo tudo volta
   a ser exatamente o que era.

   De brinde, isso herda as duas regras que o dvr-busca.js ja tem e que sao
   boas: a palavra que a PESSOA escreveu vale como comeco de palavra, entao
   "olho" acha "olhos", "gato" acha "gatos" e "lua" acha "luar"; e o que o
   DICIONARIO de equivalencias acrescentou vale so como palavra inteira, para
   "cat" dentro de "catalogo" nao virar um gato.

   A CHAVE E O APELIDO DA ARTE, nao o handle. camisa-forma-organica,
   baby-forma-organica e oversized-forma-organica caem todos em
   "forma-organica", porque o desenho e o mesmo nos tres. Isso tambem
   sobrevive de graca a troca de handle que o motor faz no cartao quando a
   pessoa escolhe outra modelagem.

   O QUE FICA DE FORA DO SACO, de proposito, e quem tira e o dvr-arte-b.liquid:
   cor de peca (branco, preto, roxo) e posicao (frente, costas, peito). Todo
   texto de arte diz quais cores de camiseta combinam com o desenho ("preto,
   roxo e vermelho sustentam bem o amarelo"), entao se essas palavras
   entrassem aqui elas deixariam de ser ACAO - hoje "estampa no peito" repinta
   a grade toda no peito - e passariam a devolver quase as 80 estampas. */
(function () {
'use strict';

var PREFIXOS = ['camiseta-', 'oversized-', 'camisa-', 'baby-'];
function apelido(h) {
  h = String(h || '');
  for (var i = 0; i < PREFIXOS.length; i++) {
    if (h.indexOf(PREFIXOS[i]) === 0) return h.slice(PREFIXOS[i].length);
  }
  return h;
}

/* mesma leitura que o motor faz: o handle autoritativo esta em data-dv2-h
   depois que o motor passou pelo cartao, e no endereco antes disso. */
function handleDe(a) {
  var h = a.getAttribute('data-dv2-h');
  if (h) return h;
  var u = a.getAttribute('href') || '', i = u.indexOf('/products/');
  if (i < 0) return '';
  return u.slice(i + 10).split('?')[0].split('#')[0].split('/')[0];
}

/* a secao do topo move a configuracao para DVR_V2CFG e apaga
   window.DVR_VITRINE antes dos scripts com defer rodarem, entao o saco e
   procurado nos tres lugares possiveis. */
function mapa() {
  if (window.DVR_ARTE_TXT) return window.DVR_ARTE_TXT;
  var c = window.DVR_V2CFG || window.DVR_VITRINE;
  return (c && c.b) || null;
}

function passa() {
  var m = mapa();
  if (!m) return 0;
  var cs = document.querySelectorAll('a.dv-card'), n = 0, i, c, s;
  for (i = 0; i < cs.length; i++) {
    c = cs[i];
    if (c.getAttribute('data-dv-arte')) continue;
    s = m[apelido(handleDe(c))];
    if (!s) continue;
    c.setAttribute('data-dv-keys', (c.getAttribute('data-dv-keys') || '') + ' ' + s);
    c.setAttribute('data-dv-arte', '1');
    /* as duas buscas guardam o texto do cartao na primeira leitura. Se alguma
       ja tiver lido este cartao, o guardado sai para ser montado de novo. */
    c.dvrbIdx = null;
    c.dvrv2Txt = null;
    n++;
  }
  return n;
}

passa();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', passa);
}
/* o motor desenha a grade em passadas, e o cartao nem sempre esta no lugar no
   primeiro instante. Algumas voltas curtas sao baratas e cobrem isso; quando
   os 80 cartoes estao marcados a volta seguinte nao faz nada. */
var voltas = 0;
var relogio = setInterval(function () {
  voltas++;
  passa();
  if (voltas > 20) clearInterval(relogio);
}, 300);
})();